<template>
  <BuilderWrapper title="Background Image">
    <LabelledInput label="Upload your background image here">
      <ImageUpload
        data-test="img-upload-custom-vis-bg-img"
        :config-path="backgroundImageConfigPath"
        :is-config="false"
      />
    </LabelledInput>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import ImageUpload from '@/components/builder/images/ImageUpload.vue'

import { CustomTabNode, CustomTabConfigKeys } from '@/types'

const components = {
  BuilderWrapper,
  LabelledInput,
  ImageUpload,
}

const props = {
  tabNode: Object as () => CustomTabNode,
}

@Component({ components })
export default class BackgroundImageSettings extends Vue.extend({ props }) {
  get backgroundImageConfigPath () {
    return [this.tabNode.path, CustomTabConfigKeys.BACKGROUND_IMAGE]
  }
}

</script>
